/* eslint-disable max-classes-per-file */
/* eslint-disable consistent-return */

import angular from 'angular';
import Quill from 'quill';
import Delta from 'quill-delta/dist/Delta';

import './editor.styles.scss';

const BlockEmbed = Quill.import('blots/block/embed');

class DividerBlot extends BlockEmbed { }
DividerBlot.blotName = 'divider';
DividerBlot.tagName = 'hr';

export const RichTextEditorComponent = {
  selector: 'richTextEditor',
  restrict: 'E',
  bindings: {
    customModel: '=',
    customModelRaw: '=?',
    placeholder: '@?',
    deltaInput: '=?',
  },
  template: /* html */`
    <div class="rich-text-editor">
      <div class="editor-wrap">
        <div id="{{ $ctrl.wrapId }}"></div>
      </div>
    </div>
  `,
  controllerAs: '$ctrl',
  controller: class RichTextEditorController {
    private quillEditor: Quill | null = null;

    public wrapId = `EDITOR-${Math.ceil(Math.random() * 1000)}`;

    public placeholder?: string;

    public customModel!: string;

    public customModelRaw?: Delta;

    constructor() {
      'ngInject';
    }

    $doCheck(): void {
      this.init();
    }

    private addHorizontalLine = (): void => {
      if (!this.quillEditor) return;

      const range = this.quillEditor.getSelection(true);
      this.quillEditor.insertText(range.index, '\n', Quill.sources.USER);
      this.quillEditor.insertEmbed(range.index + 1, 'divider', Quill.sources.USER);
    };

    private editorTextChanged = (): void => {
      if (!this.quillEditor) return;

      const returnStrings: string[] = [];
      let currentString = 0;

      this.quillEditor.getContents().forEach((o) => {
        let thisString = '';

        if (o.insert && typeof o.insert === 'string') {
          thisString = o.insert.replace(/\n/g, '\\\\');
        } else if (o.insert && (o.insert as any).divider) {
          thisString = '\n----\n';
        }

        if (o.attributes && o.attributes.bold) {
          thisString = `**${thisString}**`;
        }

        if (o.attributes && o.attributes.list && currentString > 0) {
          returnStrings[currentString - 1] = `* ${returnStrings[currentString - 1].replace(/\\/g, '')}\\\\`;
          thisString = '';
        }

        returnStrings.push(thisString);
        currentString += 1;
      });

      this.customModel = returnStrings.join('').replace(/\n/gm, '');
      if (this.customModelRaw) this.customModelRaw = this.quillEditor.getContents() as Delta;
    };

    private init = (): void => {
      if (this.quillEditor) return;

      const wrap = document.getElementById(this.wrapId);
      if (!wrap) return;

      const toolbarOptions = ['bold', { list: 'bullet' }, 'divider'];

      Quill.register(DividerBlot, true);

      this.quillEditor = new Quill(wrap, {
        placeholder: this.placeholder,
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              divider: this.addHorizontalLine,
            },
          },
        },
      });

      if (this.customModelRaw) {
        this.quillEditor.updateContents(this.customModelRaw as any);
        this.editorTextChanged();
      }

      this.quillEditor.on('text-change', () => this.editorTextChanged());
    };
  },
};

export default angular.module('components.richTextEditor', [])
  .component(RichTextEditorComponent.selector, RichTextEditorComponent)
  .name;
